module.exports = __webpack_public_path__ + "static/media/LRLE05.619fd822.jpg";